import { Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import { currencyFormat } from "@saleor/utils/formatters/currencyFormat";
import React from "react";

const useStyles = makeStyles(
  theme => ({
    cardStyle: {
      alignItems: "center",
      display: "flex",
      height: "10vh"
    },
    orderCodeStyle: {
      fontSize: "15px",
      fontWeight: 600
    },
    orderPriceStyle: {
      color: "#808080",
      fontSize: "15px"
    },
    root: {
      ...theme.typography.body1,
      lineHeight: 1.9,
      width: "100%"
    }
  }),
  { name: "RemittanceRunnerOrderDetails" }
);

export interface RemittanceRunnerOrderDetailsProps {
  orderCode: string;
  orderPrice: number;
}

const RemittanceRunnerOrderDetails: React.FC<RemittanceRunnerOrderDetailsProps> = props => {
  const { orderCode, orderPrice } = props;
  const classes = useStyles(props);

  return (
    <>
      {/* Card for Mother Order Details */}
      <div>
        <Card className={classes.cardStyle}>
          <CardContent>
            <Typography className={classes.orderCodeStyle}>
              {orderCode}
            </Typography>
            <Typography className={classes.orderPriceStyle}>
              {currencyFormat(orderPrice)}
            </Typography>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
RemittanceRunnerOrderDetails.displayName = "RemittanceRunnerOrderDetails";
export default RemittanceRunnerOrderDetails;
